import { render } from "./RegisterCtaSection.vue?vue&type=template&id=bbdf4be2&scoped=true"
import script from "./RegisterCtaSection.vue?vue&type=script&lang=js"
export * from "./RegisterCtaSection.vue?vue&type=script&lang=js"

import "./RegisterCtaSection.vue?vue&type=style&index=0&id=bbdf4be2&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbdf4be2"]])

export default __exports__